import { useAuth } from "@babackapp/auth-client/hooks";
import config from "@/config.ts";

/**
 * Link to a payment in the Stripe dashboard, or `undefined` when the log has
 * no connected account to point to.
 *
 * The account-scoped form (`/{accountId}/payments/...`) only opens for members
 * of the connected account, i.e. the merchant. Baback users are signed in to
 * our platform account, which reaches connected accounts through
 * `/{platformId}/connect/accounts/{accountId}/...` (BBS-348).
 */
export default function useStripePaymentUrl(
  accountId: string | undefined,
  transactionId: string | undefined,
): string | undefined {
  const { user } = useAuth();

  if (!accountId || !transactionId) return undefined;

  const email = user?.emails?.[0]?.address?.toLowerCase() ?? "";
  const platformId = config.stripePlatformAccountId;
  // `vite build` sets PROD for staging too, so the mode comes from the key the
  // payments were made with.
  const isTestMode = config.stripePublicKey
    ? config.stripePublicKey.startsWith("pk_test_")
    : !config.isProd;
  const testUri = isTestMode ? "test/" : "";

  if (platformId && email.endsWith("@baback.co")) {
    return `https://dashboard.stripe.com/${platformId}/${testUri}connect/accounts/${accountId}/payments/${transactionId}`;
  }

  return `https://dashboard.stripe.com/${accountId}/${testUri}payments/${transactionId}`;
}
